import { render, staticRenderFns } from "./video-events-cards.vue?vue&type=template&id=ee0a030a&scoped=true&"
import script from "./video-events-cards.vue?vue&type=script&lang=js&"
export * from "./video-events-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0a030a",
  null
  
)

export default component.exports